import quickToolDataFactory from './quickToolData.factory';
import quickToolService from './quickTool.service';
import stQuickToolHomeLoanRefinanceAnalysis from './homeLoanRefinanceAnalysis.component';
import stQuickToolHomeLoanMaximumBorrowing from './homeLoanMaximumBorrowing.component';
import stQuickToolHomeLoanFundingWorksheet from './homeLoanFundingWorksheet.component';
import stQuickToolHomeLoanCompareProducts from './homeLoanCompareProducts.component';
import stQuickToolAssetFinanceQuotingCalculator from './assetFinanceQuotingCalculator.component';
import stQuickToolAssetFinanceQuickQuote from './assetFinanceQuickQuote.component';
import aolSilentLogin from './aolSilentLogin.component';

export default angular
  .module('st.QuickTool', [
    'st.Core',
    'angular-cache',
    'st.Core.GoogleMaps',
    'ui.utils.masks',
    'vsGoogleAutocomplete'
  ])
  .factory('quickToolDataFactory', quickToolDataFactory)
  .service('quickToolService', quickToolService)
  .component('stQuickToolHomeLoanRefinanceAnalysis', stQuickToolHomeLoanRefinanceAnalysis)
  .component('stQuickToolHomeLoanMaximumBorrowing', stQuickToolHomeLoanMaximumBorrowing)
  .component('stQuickToolHomeLoanFundingWorksheet', stQuickToolHomeLoanFundingWorksheet)
  .component('stQuickToolHomeLoanCompareProducts', stQuickToolHomeLoanCompareProducts)
  .component(
    'stQuickToolAssetFinanceQuotingCalculator',
    stQuickToolAssetFinanceQuotingCalculator
  )
  .component('stQuickToolAssetFinanceQuickQuote', stQuickToolAssetFinanceQuickQuote)
  .component('aolSilentLogin', aolSilentLogin)
  .constant('QUICK_TOOL', {
    API: {
      GENERATE_BASE64_FROM_IMAGE_URL: '/api/v1/quick-tools/generate-base64-from-image-url/'
    }
  });
